import User from "../data/User";
import Api, { ApiCallback } from "./Api";
import { ApiErrors } from "./ApiErrors";

export class ApiAccess{

    URL_LOGIN:string = 					"PSAPLink_Service/PSAPLinkWS/User_Login";
    URL_LOGOUT:string = 				"laaser_SL_PSAP_user_logout";
    
    async userLogin($complete:ApiCallback,$details?:{email:string, password:string, epocTime:string}){
        let success:boolean=false;
        let error = ApiErrors.LOADING;//default

        try{

            const loginRequest:any = {};
            loginRequest.authorization = Api.createAuthBlock();
    
            if($details){
                loginRequest.email = $details.email;
                loginRequest.passcode = $details.password;
                loginRequest.epoch_time = $details.epocTime;

            }else if(User.state.isRestoring && User.state.loginToken){
                loginRequest.token = User.state.loginToken;
            }
            
            loginRequest.push_token = User.pushToken;
            loginRequest.device_id = User.deviceID;
            loginRequest.push_method = "web";
            loginRequest.include_shapes = true;

            loginRequest.parm_filter="ECRCPSAPLINK";

            let strURL:string = Api.strEvnURL+this.URL_LOGIN;

            console.log(Api.strEvnURL+this.URL_LOGIN);
            const loginResponse:any = await Api.fetchAsyncJSON(strURL,"POST",loginRequest);

            if(loginResponse && loginResponse.summary){
                //valid response
                if(loginResponse.summary.success){
                    //success... but now check if we are allowed
                    if(loginResponse.summary.user_rights && (loginResponse.summary.user_rights.PSAP_LINK_ACCESS)){
                        success=true;

                        let email:string = "";
                        if($details?.email){
                            email = $details.email;
                        }
                        if(email==="" && User.state.loginEmail){//check for if it was set from a carryOver
                            email=User.state.loginEmail;
                        }

                        User.login(email, loginResponse);
                

                    }else{
                        error = ApiErrors.INVALIDUSERRIGHTS;
                    }
                }else{
                    if(loginResponse.summary.code){
                       let errorFromCode = ApiErrors.findErrorWithCode(loginResponse.summary.code);
                        if(errorFromCode){
                            error = errorFromCode;
                        }
                    }
                }

                if(success){
                    $complete(true,loginResponse);
                }else{
                    //specific error
                    $complete(false,error);
                }

            }else{
                //basic error                
                $complete(false,error);
            }

        }catch($error){
            //loading error
            $complete(success,error);
            
        }

    }


    async login($complete:ApiCallback,$details?:{username:string, password:string, psapId:string}){
        let success:boolean=false;
        let error = ApiErrors.LOADING;//default

        try{

            const loginRequest:any = {};
            loginRequest.authorization = Api.createAuthBlock();
    
            if($details){
                loginRequest.psap_id = $details.psapId;
                loginRequest.username = $details.username;
                loginRequest.passcode = $details.password;
            }else if(User.state.isRestoring && User.state.loginToken){
                loginRequest.token = User.state.loginToken;
            }
            
            loginRequest.push_token = User.pushToken;
            loginRequest.device_id = User.deviceID;
            loginRequest.push_method = "web";
            loginRequest.include_shapes = true;

            loginRequest.parm_filter="ECRCPSAPLINK";

            let strURL:string = Api.strEvnURL+this.URL_LOGIN;

            const loginResponse:any = await Api.fetchAsyncJSON(strURL,"POST",loginRequest);

            if(loginResponse && loginResponse.summary){
                //valid response
                if(loginResponse.summary.success){
                    //success... but now check if we are allowed
                    if(loginResponse.summary.user_rights && (loginResponse.summary.user_rights.PSAP_LINK_ACCESS)){
                        success=true;

                        let username:string = "";
                        if($details?.username){
                            username = $details.username;
                        }
                        if(username==="" && User.state.loginUsername){//check for if it was set from a carryOver
                            username=User.state.loginUsername;
                        }

                        User.login(username, loginResponse);
                

                    }else{
                        error = ApiErrors.INVALIDUSERRIGHTS;
                    }
                }else{
                    if(loginResponse.summary.code){
                       let errorFromCode = ApiErrors.findErrorWithCode(loginResponse.summary.code);
                        if(errorFromCode){
                            error = errorFromCode;
                        }
                    }
                }

                if(success){
                    $complete(true,loginResponse);
                }else{
                    //specific error
                    $complete(false,error);
                }

            }else{
                //basic error                
                $complete(false,error);
            }

        }catch($error){
            //loading error
            $complete(success,error);
            
        }

    }

    
    async logout(){

        User.logout();
        //we dont' care about any response
        try{
            const loginRequest:any = {};
            loginRequest.authorization = Api.createAuthBlock();    

            if(!User.state.loginToken){
               return;
            }    

            loginRequest.loginToken = User.state.loginToken;

            let strURL:string = Api.strEvnURL+this.URL_LOGOUT;

            const loginResponse:any = await Api.fetchAsyncJSON(strURL,"POST",loginRequest, {isLogout:true});

            localStorage.clear();
            
        }catch($error){

        }

    }

    checkForInvalidToken($response:any){
        let invalidToken:boolean=false;
        if($response.summary && $response.summary.code && $response.summary.code===81){
            invalidToken=true;
        }

        return invalidToken;
    }


}